export const generateDeliveryLink = (customerId) => {
    const baseUrl = window.location.origin;
    const encodedId = btoa(customerId); // Base64 encode
    return `${baseUrl}/submit-delivery/${encodedId}`;
};

export const transformTrackingData = (courier, rawData) => {
    switch (courier) {
        case 'acx':
            const docket = rawData?.data?.[0]; // Assuming only one docket
            if (!docket) return null;

            const history = (docket?.docket_events || [])?.map((event) => ({
                event_time: event?.event_at,
                location: event?.event_location,
                message: event?.event_description,
            })).sort((a, b) => new Date(b?.event_time) - new Date(a?.event_time));

            // Convert docket_info array into an object for easy access
            const docketInfo = Object.fromEntries(docket?.docket_info || []);

            const details = {
                weight: docket?.chargeable_weight,
                weightUnit: 'kg',
                destination: `${docketInfo["Consignee City"]}  ${docketInfo["Destination"]} ` || docketInfo["Consignee Country"],
                altReferenceNumber: docket?.forwarding_no
            };

            return {
                history,
                details,
            };

        case 'dtdc':
            const events = (rawData?.data?.trackDetails || []).map((event) => {
                const dateStr = event?.strActionDate; // format: DDMMYYYY
                const timeStr = event?.strActionTime; // format: HHmm

                let eventDate;
                if (dateStr?.length === 8 && timeStr?.length >= 4) {
                    const day = dateStr.slice(0, 2);
                    const month = dateStr.slice(2, 4);
                    const year = dateStr.slice(4, 8);
                    const hour = timeStr.slice(0, 2);
                    const minute = timeStr.slice(2, 4);

                    eventDate = new Date(`${year}-${month}-${day}T${hour}:${minute}:00`);
                } else {
                    eventDate = new Date();
                }

                return {
                    event_time: eventDate.toLocaleString(),
                    location: event?.strOrigin,
                    message: event?.strAction,
                };
            }).reverse();

            const additionalDetails = {
                weight: rawData?.data?.trackHeader?.strWeight,
                weightUnit: rawData?.data?.trackHeader?.strWeightUnit,
                destination: rawData?.data?.trackHeader?.strDestination,
                altReferenceNumber: rawData?.data?.trackHeader?.strAltReferenceNumber,
            };

            return {
                history: events,
                details: additionalDetails,
            };

        case 'skynet':
            const historyData = (rawData?.data?.ShipmentHistory || [])
                .map((event) => ({
                    event_time: `${event?.Date} ${event?.Time}`,
                    location: event?.Location,
                    message: `${event?.ShipmentStatus} - ${event?.ShipmentDetails}`,
                })).sort((a, b) => new Date(b?.event_time) - new Date(a?.event_time)); // latest first


            const shipment = rawData?.data?.ShipmentDetails?.[0] || {};
            const detailsData = {
                weight: shipment?.Weight,
                weightUnit: 'kg',
                destination: shipment?.Destination,
                altReferenceNumber: shipment?.ForwarderNo,
            };

            return {
                history: historyData,
                details: detailsData,
            };
        default:
            return [];
    }
};
